// extracted by mini-css-extract-plugin
module.exports = {"vacationPage":"YkJg0","vacationChartLayout":"otev+","vacationYearChartsLayout":"swLJ2","vacationAllTimeChartsLayout":"Hqa+j"};